import React, { useEffect, useState, useCallback } from 'react';
import { Dispatch, RootState } from '../../store/store';
import { connect } from 'react-redux';
import { ROLES } from '../../constants/roles';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import { generatePath, useNavigate } from 'react-router-dom';
import ROUTE from '../../constants/route-constants';
import DeniedAccess from '../DeniedAccess/DeniedAccess';

type ComponentProps = {
  children: React.ReactNode,
} & ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const TITLE_ERROR = 'Sorry, the page can’t be available for you';
const NO_LOCATION_ASSIGNED_MESSAGE = 'Please ask organization members to assign you a location.';

const HomePageChecker: React.FC<ComponentProps> = ({ children, currentMember, getLocations }) => {
  const navigate = useNavigate();
  const [isDeniedAccess, setIsDeniedAccess] = useState<boolean>(false);

  const moveToCustomerHomePage = useCallback(async () => {
    const locations = await getLocations();
    if (locations.length > 1) {
      navigate(ROUTE.LOCATIONS);
    } else if (locations.length === 1) {
      const path = generatePath(ROUTE.LOCATION_CONTRACTS, { clientId: locations[0].id });
      navigate(path);
    } else {
      setIsDeniedAccess(true);
    }
  }, [getLocations, navigate]);

  useEffect(() => {
    if (currentMember.role === ROLES.CUSTOMER) {
      moveToCustomerHomePage();
    }
  }, []);

  if (currentMember.role !== ROLES.CUSTOMER) return children;

  if (isDeniedAccess) {
    return <DeniedAccess title={TITLE_ERROR} subTitle={NO_LOCATION_ASSIGNED_MESSAGE} />;
  }

  return (
    <div className='w-full h-full flex justify-center items-center'>
      <SpinnerLoader />
    </div>
  );
};

const mapState = (state: RootState) => ({
  currentMember: state.user.profile?.memberData,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getLocations: dispatch.locations.getLocations,
});

export default connect(mapState, mapDispatch)(HomePageChecker);
